import { create } from "zustand";
import { devtools, persist, createJSONStorage } from "zustand/middleware";

export const useUIStore = create<{
  floatingPanelPositions: Record<string, { x: number; y: number }>;
  setFloatingPanelPosition: (panelId: string, position: { x: number; y: number }) => void;
  getFloatingPanelPosition: (panelId: string) => { x: number; y: number } | undefined;
  settingsOpen: boolean;
  setSettingsOpen: (open: boolean) => void;
  hotkeyHelpOpen: boolean;
  setHotkeyHelpOpen: (open: boolean) => void;
  feedbackOpen: boolean;
  setFeedbackOpen: (open: boolean) => void;
  leftPanelView: "nav" | "map";
  setLeftPanelView: (view: "nav" | "map") => void;
  debugOpen: boolean;
  setDebugOpen: (open: boolean) => void;
}>()(
  devtools(
    persist(
      (set, get) => ({
        floatingPanelPositions: {},
        setFloatingPanelPosition: (panelId, position) =>
          set((state) => ({
            floatingPanelPositions: {
              ...state.floatingPanelPositions,
              [panelId]: position,
            },
          })),
        getFloatingPanelPosition: (panelId) => get().floatingPanelPositions[panelId],
        settingsOpen: false,
        setSettingsOpen: (open) => set({ settingsOpen: open }),
        hotkeyHelpOpen: false,
        setHotkeyHelpOpen: (open) => set({ hotkeyHelpOpen: open }),
        feedbackOpen: false,
        setFeedbackOpen: (open) => set({ feedbackOpen: open }),
        leftPanelView: "nav",
        setLeftPanelView: (view) => set({ leftPanelView: view }),
        debugOpen: false,
        setDebugOpen: (open) => set({ debugOpen: open }),
      }),
      {
        name: "ui-storage",
        storage: createJSONStorage(() =>
          process.env.VITEST
            ? { getItem: () => null, setItem: () => {}, removeItem: () => {} }
            : localStorage
        ),
      }
    ),
    { name: "UIStore", trace: process.env.NODE_ENV === "development" }
  )
);
